module.exports = __webpack_public_path__ + "img/sticker_4.9b9169b4.svg";